import HTTPService from '@/services/Http';
import logrocket from '@/services/logrocket';

async function fetchTransaction(state, publicId) {
  try {
    const { data } = await HTTPService.getTransaction(publicId);

    state.commit('SET_TRANSACTION', data);
  } catch (error) {
    logrocket.logger(error);
    throw new Error;
  }
}

export default {
  fetchTransaction,
};
